"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[716],{

/***/ 716:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SizeGuide)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function SizeGuide() {
  const settings = {
    guideSelect: '[data-guide-select]',
    guideListBtn: '[data-guide-btn]',
    accordionTrigger: '[data-accordion-trigger]',
  }

  ;(async function init() {
    initializeEventListeners()
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.guideSelect).on('change', scrollToGuide)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.guideListBtn).on('click', scrollToGuide)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accordionTrigger).on('click', toggleAccordion)
  }

  function scrollToGuide(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    let guideSelected

    if (typeof jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).data('guide-select') !== 'undefined') {
      guideSelected = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.guideSelect).find(':selected').val()
    } else if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).data('guide')) {
      guideSelected = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).data('guide')
    }

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(guideSelected).find(settings.accordionTrigger).attr('aria-expanded') === 'false') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(guideSelected).find(settings.accordionTrigger).trigger('click')
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(guideSelected)[0].scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }

  function toggleAccordion(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    const target = e.currentTarget
    const isExpanded = JSON.parse(target.getAttribute('aria-expanded'))
    const contentID = target.getAttribute('aria-controls')
    const content = document.querySelector(`#${contentID}`)

    if (!isExpanded) {
      // Open accordion
      target.setAttribute('aria-expanded', 'true')
      slideDown(content)
      content.removeAttribute('hidden')
    } else {
      // Close accordion
      target.setAttribute('aria-expanded', 'false')
      slideUp(content)
      content.setAttribute('hidden', 'true')
    }
  }

  function slideDown(element) {
    element.style.display = 'block'
    element.style.height = '0px'
    element.style.overflow = 'hidden'

    const height = element.scrollHeight
    element.style.transition = 'height 0.3s ease'
    element.style.height = height + 'px'

    setTimeout(() => {
      element.style.height = 'auto'
      element.style.overflow = ''
    }, 300)
  }

  function slideUp(element) {
    const height = element.scrollHeight
    element.style.height = height + 'px'
    element.style.overflow = 'hidden'
    element.style.transition = 'height 0.3s ease'

    setTimeout(() => {
      element.style.height = '0px'
    }, 10)

    setTimeout(() => {
      element.style.display = 'none'
      element.style.height = ''
      element.style.overflow = ''
    }, 300)
  }
}


/***/ })

}]);